import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import GlobalFilterComponent from '../../../../components/GlobalFilterComponent';
import {GetErpTypeFromConfig} from "../../../MainPage/Layout_responsive";
const columns = [
  { field: 'name', Text: 'name' },
  { field: 'code', Text: 'code' },
  { field: 'description', Text: 'description' },
  { field: 'alias', Text: 'alias' },
];
const WorkordersFilterTabs = () => {
  const ERP_TYPE =GetErpTypeFromConfig();
  const begin = (args: any) => {
    if (args.isSwiped) {
      args.cancel = true;
    }
  };
  return (
    <div className='main-content-order-request'>
      <TabComponent
        enablePersistence={true}
        selecting={begin.bind(this)}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          {ERP_TYPE !== 'MEX' && (
            <TabItemDirective
              header={{ text: 'Responsibility' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$responsibility'}
                    enableOrgEdit
                  />
                </>
              )}
            />
          )}
          <TabItemDirective
            header={{ text: 'Status' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$status'}
                  enableOrgEdit
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Type' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$type'}
                  enableOrgEdit
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Priority' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$priority'}
                  enableOrgEdit
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: ERP_TYPE !== 'PRONTO' ? 'Branch' : 'Department' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'workorders$department'}
                  enableOrgEdit
                />
              </>
            )}
          />
          {ERP_TYPE !== 'MEX' && (
            <TabItemDirective
              header={{ text: 'Section' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$section'}
                    enableOrgEdit
                  />
                </>
              )}
            />
          )}
          {ERP_TYPE !== 'MEX' && (
            <TabItemDirective
              header={{ text: 'Reason' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$reason'}
                    enableOrgEdit
                  />
                </>
              )}
            />
          )}
          {ERP_TYPE !== 'MEX' && (
            <TabItemDirective
              header={{ text: 'Reference' }}
              content={() => (
                <>
                  <GlobalFilterComponent
                    columns={columns}
                    query={'workorders$reference'}
                    enableOrgEdit
                  />
                </>
              )}
            />
          )}
            {ERP_TYPE !== 'MEX' && (
                <TabItemDirective
                    header={{ text: 'Revision' }}
                    content={() => (
                        <>
                            <GlobalFilterComponent
                                columns={columns}
                                query={'workorders$revision'}
                                enableOrgEdit
                            />
                        </>
                    )}
                />
            )}
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
};

export default WorkordersFilterTabs;
